var _rect, _path, _rect2, _path2, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorBaggageService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.164,
    y: 27.547,
    width: 4.964,
    height: 11.16,
    transform: "translate(-16.04 10.091) rotate(-31.879)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.298,28.999h5.034c1.386,0,2.509-1.123,2.509-2.509h0c0-1.386-1.123-2.509-2.509-2.509h-8.078c-1.351,0-2.657.487-3.679,1.371l-3.725,3.224,3.794,6.421h10.175c2.432,0,4.765-.966,6.484-2.686l6.37-6.37c.98-.98.98-2.568,0-3.548h0c-.98-.98-2.569-.98-3.548,0l-6.065,6.065c-.347.347-.818.542-1.309.542"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.076,
    y: 5.014,
    width: 19.848,
    height: 13.275,
    rx: 2.32,
    ry: 2.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.325,2.824h1.35c1.209,0,2.19.981,2.19,2.19h-5.729c0-1.209.981-2.19,2.19-2.19Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14.918,
    y1: 5.014,
    x2: 14.918,
    y2: 18.288
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 27.082,
    y1: 5.014,
    x2: 27.082,
    y2: 18.288
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorBaggageService);
export default __webpack_public_path__ + "static/media/indoor-baggage_service.97584dc83261586041262d2361d88761.svg";
export { ForwardRef as ReactComponent };